import React, { FC }           from 'react';
import styled                  from 'styled-components';
import { IBidderUser }         from '@typings/registeredBidders';
import { TSelectOnChange }     from '@typings/components';
import { formatFullName }      from '@utils/commonFunctions';
import { bidderStatusOptions } from '@modules/registeredBidders/utils/suggestions';
import { Select }              from '@components/index';

const LineWrapper = styled.div`
  display       : flex;
  align-items   : center;
  width         : 800px;
  padding       : 0 5px;
  margin-bottom : 5px;

  span {
    color     : ${({ theme: { textColor } }): string => textColor.black};
    font-size : 16px;
  }

  > span:first-child {
    flex-basis  : 160px;
    text-align  : right;
    white-space : nowrap;
  }

  > span:last-child {
    flex-basis  : 200px;
    margin-left : 15px;
  }
`;

interface IProps {
  user           : IBidderUser;
  onChangeStatus : TSelectOnChange;
}

export const UserDetails: FC<IProps> = ({ user, onChangeStatus }) => (
  <>
    <LineWrapper>
      <span>Name:</span>
      <span>{formatFullName(user)}</span>
    </LineWrapper>

    <LineWrapper>
      <span>Address 1:</span>
      <span>{user?.address1 ?? ''}</span>
    </LineWrapper>

    <LineWrapper>
      <span>Address 2:</span>
      <span>{user?.address2 ?? ''}</span>
    </LineWrapper>

    <LineWrapper>
      <span>City, State, Zip:</span>
      <span>{user?.city ?? ''} {user?.state ?? ''} {user?.zip ?? ''}</span>
    </LineWrapper>

    <LineWrapper>
      <span>Phone:</span>
      <span>{user?.phone ?? ''}</span>
    </LineWrapper>

    <LineWrapper>
      <span>Email:</span>
      <span>{user?.email ?? ''}</span>
    </LineWrapper>

    <br />

    <LineWrapper>
      <span>Dealer ID:</span>
      <span>{user?.dealerInfo?.dealerId ?? ''}</span>
    </LineWrapper>

    <br />

    <LineWrapper>
      <span>Status:</span>
      <span>
        <Select
          width    = "350px"
          value    = {user.status}
          options  = {bidderStatusOptions}
          onChange = {onChangeStatus}
        />
      </span>
    </LineWrapper>

    <br />
  </>
);
